import requestor from "requestor";
import React from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import CircularProgress from "@material-ui/core/CircularProgress";

import testSetAddAction from "modules/flowmaster/actions/testset_add";

import Permissioner from "utils/permissioner";
import {isInitialised} from "utils/uninitialised";
import setTitle from "utils/set_title";
import TestsComponent from "../components/tests";

import {RouterState, InjectedRouter} from "react-router/lib/Router";
import {Organisation} from "common/types/organisation";
import {User} from "common/types/user";
import {AggregatedWorkflowTest, TestSet} from "common/flowmaster/types/test";

interface Props {
  user: User;
  router: RouterState & InjectedRouter;
  location: Location;
  params: {
    organisationId: string;
  };
  dispatch: (args: unknown) => unknown;
  organisation: Organisation;

  workflowTests: AggregatedWorkflowTest[];
  testsets: TestSet[];
  addTestSetAction: (organisationId: number, name: string) => void;
}
function TestsContainer({
  user,
  router,
  workflowTests,
  testsets,
  addTestSetAction,
}: Props) {
  const organisationId = parseInt(router.params.organisationId, 10);

  const permissioner = new Permissioner(user);
  if (
    !(permissioner.hasPermission("get-workflows") || permissioner.isAdmin())
  ) {
    return permissioner.getNoPermissionMessage();
  }

  setTitle("LLM Run Scores");

  const shouldRenderContainer = isInitialised([user, workflowTests, testsets]);
  if (!shouldRenderContainer || !user.permissions) {
    return (
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  async function addTestSet(name: string) {
    await addTestSetAction(organisationId, name);
  }

  return (
    <TestsComponent
      organisationId={organisationId}
      workflowTests={workflowTests}
      testsets={testsets}
      addTestSet={addTestSet}
    />
  );
}

function select(state) {
  return {
    user: state.user,
    organisation: state.organisation,
    workflowTests: state.workflowTests,
    testsets: state.testsets,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators(
      {
        addTestSetAction: testSetAddAction(requestor),
      },
      dispatch,
    ),
  };
}

export default connect(select, mapDispatchToProps)(TestsContainer);
